<!--
     <DynamicForm
       :fields="my_fields"
       @error="alert"
     />

     Public methods
       validate() → Validates the data and returns true if data is valid.
       clear()    → Clears all inputs
       get_data() → Returns a filled FormData() instance,
                    NOTE: Fields returning /undefined/ value are ignored.

     fields = [ // rows
         [ // cols
             {
               component: "TextInput",
               cols: 4, // Col size int, [1 ↔ 12].
               hidden: false // Hides the field
               id: "Unique component name for the form",
               ... // Extra propertys will be forwarded to the component
             }
         ]
     ]

     NOTE: For hidden fields, their default value is used
-->

<template>
  <v-form
    v-model="form"
  >
    <v-row
      dense
      v-for="row in fields"
      :key="row.map((f) => f.id).join('|')"
    >
      <v-col
        v-for="field in row"
        :key="field.id"
        :cols="field.cols"
      >
        <component
          v-bind:is="field.component"
          :ref="field.id"
          :id="field.id"
          :props="field"
          @bind="create_bind"
        ></component>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
import TextInput from '@/components/inputs/TextInput'
import Select from '@/components/inputs/Select'
import DateInput from '@/components/inputs/DateInput'
import TextareaInput from '@/components/inputs/TextareaInput'
import NumericInput from '@/components/inputs/NumericInput'
import FileInput from '@/components/inputs/FileInput'
import ProcessDependingUserField from '@/components/inputs/ProcessDependingUserField'
import DirectoryInput from '@/components/inputs/DirectoryInput'
import Tag from '@/components/inputs/Tag'

export default {
  components: {
    TextInput,
    Select,
    DateInput,
    TextareaInput,
    NumericInput,
    FileInput,
    ProcessDependingUserField,
    DirectoryInput,
    Tag,
  },

  name: 'DynamicForm',

  props: ['fields'],

  data: () => ({
    form: null,
  }),

  computed: {
    fieldlist() {
      // Returns a list with all fields [field1, field2...]
      return this.fields.flat()
    },
    is_valid() {
      return this.form
    },
    //  is_non_empty(){
    //   for (const field of this.fieldlist) {
    //     console.log(field.id)
    //     if (!field.hidden){
    //       let value = document.getElementById(field.id).__vue__.value;
    //       if (value){
    //         return true;
    //       }
    //     }
    //   }
    //   return false
    //  }
  },

  methods: {
    validate() {
      // Validates all fields and returns if all of them are valid
      let v = !this.fieldlist.some(
        (f) => this.$refs[f.id].validate && !this.$refs[f.id].validate(),
      )
      console.log('Dynamic_form.validate', v)
      //  return !this.fieldlist.some(f => this.$refs[f.id].validate && !this.$refs[f.id].validate());
      return v
    },

    get_data() {
      // Returns a FormData() with the data of all fields
      var fdata = new FormData()
      let value = null
      for (const field of this.fieldlist) {
        console.log('DEBUG DynamicForm.', field)
        if (field.hidden) fdata.append(field.id, field.value)
        else {
          value = document.getElementById(field.id).__vue__.value

          if (value !== undefined && value != null) {
            console.log('DEBUG DynamicForm.get_data(): field=', field.id, value)
            fdata.append(field.id, value)
          }
        }
      }
      console.log('DEBUG DynamicForm.get_data() return keys', fdata.get('Hola'))
      return fdata
    },

    clear() {
      // Clears all inputs value
      for (let row of this.fields)
        for (let field of row)
          if (!field.readonly && !field.hidden && field.value)
            field.value = null
    },

    create_bind(base_id, target_id, callback) {
      console.log(
        'create_bind(base_id =',
        base_id,
        ' , target_id = ',
        target_id,
        ' , callback = ',
        callback,
      )
      let elem = document.getElementById(target_id)
      if (elem && elem.__vue__) {
        this.$watch(() => elem.__vue__.value, callback)
        /* NOTE: We use elem.__vue_ because stored references (this.$refs)
          don't work as expected here, they don't properly update props. */
      }
    },
  },

  watch: {
    is_valid(val) {
      this.$emit('ready', val)
    },
  },
}
</script>
